import React from "react";
import { useTranslation } from "react-i18next";
import { getPasswordRequirements } from "@/core/auth/utils/password.utils";
import styles from "./index.module.scss";

interface PasswordRequirementsProps {
  /** O an girilen parola */
  password: string;
  /** Kullanıcı henüz yazmaya başlamadıysa (boş) liste yine de gösterilir; gizlemek için false geçilebilir */
  visible?: boolean;
}

/**
 * Parola politikası kurallarını canlı bir checklist olarak gösterir.
 * Sağlanan kural yeşil tik, sağlanmayan kural gri/kırmızı ile işaretlenir.
 * Böylece kullanıcı "Değiştir" butonu neden pasif anlar.
 */
const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password, visible = true }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  const requirements = getPasswordRequirements(password);

  return (
    <ul className={styles.list} aria-label={t("passwordRules.title")}>
      {requirements.map((req) => (
        <li
          key={req.key}
          className={`${styles.item} ${req.met ? styles.met : styles.unmet}`}
        >
          <span className={styles.icon} aria-hidden="true">
            {req.met ? "✓" : "✕"}
          </span>
          <span className={styles.label}>{t(req.labelKey)}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
